import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLeftinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeWidth: 2,
		d: "M16.462 20.505L7.86 12.058l8.602-8.446",
		fill: "none",
		strokeLinecap: "square",
		strokeLinejoin: "round"
	})
});
export default SvgChevronLeftinline;
